import makeStyles from '@material-ui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  button: {
    width: '100%',
    background: 'white',
    border: '1px solid #e8e8e8',
    padding: '28px',
    fontSize: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    minHeight: 150,
    maxHeight: 300,
    color: '#596375',
    '&:hover': {
      boxShadow: '0 2px 2px 0 rgba(0,0,0,.18), 0 13px 24px 0 hsla(0,0%,62%,.1)',
      background: 'rgba(248, 248, 248, 0.6)',
    },

    '& strong': {
      marginBottom: 4,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 600,
      '& img': {
        marginLeft: 6,
      },
    },
  },
  title: {
    textAlign: 'center',
    color: '#192542',
    '& > h1': {
      marginBottom: 24,
    },
  },
  paper: {
    padding: '4rem',
    width: '80vw',
    maxWidth: 900,
    margin: '0 auto',
    borderRadius: 4,
    textAlign: 'center',
  },
}));
